
export const ROOT_SCOPE_VARIABLES = {
    ORDER: {
        NEW_ORDER: 'app.orders.neworder',
        NEW_ORDER_PANEL: 'app.orders.neworderpanel',
        NEW_ORDER_PANEL_CLOSE: 'app.orders.neworderpanel.close',
        NEW_ORDER_PANEL_DETAILS: 'app.orders.neworderpanel.details',
    },
    SHIPMENT: {
        NEW_SHIPMENT: 'app.shipments.newshipment',
        NEW_SHIPMENT_PANEL: 'app.shipments.newshipmentpanel',
        NEW_SHIPMENT_PANEL_CLOSE: 'app.shipments.newshipmentpanel.close', 
        NEW_SHIPMENT_PANEL_DETAILS: 'app.shipments.newshipmentpanel.details',
    },
    LANGUAGE: {
        SELECTED_LANGUAGE_SET: 'app.language.set',
    },
    CONFIG: {
        SERVICES_DOMAINS: 'app.config.servicesdomains',
    },
    PERMISSIONS: {
        PERMISSIONS_SET: 'app.permissions.set',
        PLANNING_DAILYPLAN: {
			MODULE: "APP.PLANNING_DAILYPLAN.MODULE",
			PLANNING: {
				FINISH: "APP.PLANNING_DAILYPLAN.PLANNING.FINISH",
				ADDORDERS: "APP.PLANNING_DAILYPLAN.PLANNING.ADDORDERS",
				ADDSHIPMENTS: "APP.PLANNING_DAILYPLAN.PLANNING.ADDSHIPMENTS",
				MAKESHIPMENTBYORDER: "APP.PLANNING_DAILYPLAN.PLANNING.MAKESHIPMENTBYORDER",
				TASKORDER: "APP.PLANNING_DAILYPLAN.PLANNING.TASKORDER",
				SHOWORDER: "APP.PLANNING_DAILYPLAN.PLANNING.SHOWORDER",
				SHOWSHIPMENT: "APP.PLANNING_DAILYPLAN.PLANNING.SHOWSHIPMENT"
			},
			LOADINGUNLODINGVIEW: "APP.PLANNING_DAILYPLAN.LOADINGUNLODINGVIEW"
		},
        UNAVAILABILITY: {
            MODULE: 'APP.ADMIN.UNAVAILABILITY.MODULE',
            EDIT: 'APP.ADMIN.UNAVAILABILITY.EDIT',
            STATUSCHANGE: 'APP.ADMIN.UNAVAILABILITY.STATUSCHANGE',
            REPORT: 'APP.ADMIN.UNAVAILABILITY.REPORT',
            ACCESS: {
                TODRIVERS: 'APP.ADMIN.UNAVAILABILITY.ACCESS.TODRIVERS',
                TOVEHICLES: 'APP.ADMIN.UNAVAILABILITY.ACCESS.TOVEHICLES',
                TODEVICES: 'APP.ADMIN.UNAVAILABILITY.ACCESS.TODEVICES',
                TOUSERS: 'APP.ADMIN.UNAVAILABILITY.ACCESS.TOUSERS',
                TOCARRIERS: 'APP.ADMIN.UNAVAILABILITY.ACCESS.TOCARRIERS'
            }
        },
    },
    PLANNER_VIEW_EDIT_ROUTE:{
        MODAL_CLOSE: 'app.plannervieweditroute.modalclose'
    }

}